export const COLORS = {
    LINK: '#F2501B',
    LINK_HOVER: '#D34317',
    MAIN_BACKGROUND: '#EDEAEA59',
    HEADER_FOOTER_BACKGROUND: '#EDEDED'
}

export const CONTAINERS = {
    HEADER: {
        MOBILE: '150px',
        DESKTOP: '75px'
    },
    BODY: {
        MOBILE: 'calc(100vh - 200px)',
        DESKTOP: 'calc(100vh - 125px)'
    },
    FOOTER: {
        MOBILE: '50px',
        DESKTOP: '50px',
    }
}

export const SOCIAL_LINKS = {
    TWITTER: 'https://twitter.com/SilverJaw82',
    GITHUB: 'https://github.com/SterlingChin',
    LINKED_IN: 'https://www.linkedin.com/in/sterlingchin/',
    EMAIL: 'mailto:sterling.chin@gmail.com',
}